{
  "Breadcrumbs": {
    "podcasts": "Podcasts"
  },
  "Tenants": {
    "Provisioning": {
      "_comment": "English-only by design: operator-facing tooling, not customer-facing UI. Mirrors en-US verbatim.",
      "NewTenant": "New Pool Tenant",
      "Title": "Create Pool Tenant",
      "Subdomain": "Subdomain",
      "SubdomainPlaceholder": "e.g. acme",
      "SubdomainHint": "3-31 chars, lowercase letter then alphanumeric/hyphens. Input is normalized automatically (umlauts, spaces, pasted URLs)",
      "DisplayName": "Display Name",
      "ContactEmail": "Customer administrator email",
      "ContactEmailHint": "Receives the Company Administrator invite. Simon is added as platform administrator; Simon and Max receive provisioning notifications.",
      "ContactFirstname": "First Name (optional)",
      "ContactLastname": "Last Name (optional)",
      "ContactPhone": "Phone (optional)",
      "Trial": "Trial (14 days)",
      "TrialHint": "Trial tenants become read-only after 14 days and are deleted after 35 days unless they are activated in the tenant list.",
      "SampleContent": "Add sample podcast (Podcast Mastery)",
      "SampleContentHint": "Seeds the sample podcast with its episodes into the new tenant, so it does not start empty.",
      "FeatureFlags.Title": "Advanced settings",
      "FeatureFlags.Description": "Feature flags inherit their global defaults. Changes made here are stored only as tenant-specific overrides.",
      "FeatureFlags.SelectedCount": "{{selected}} of {{total}} enabled",
      "FeatureFlags.Loading": "Loading feature flags…",
      "FeatureFlags.Empty": "No feature flags are available. The tenant will inherit the global configuration.",
      "FeatureFlags.LoadFailed": "Feature flags could not be loaded. Global defaults will be inherited.",
      "FeatureFlags.DefaultOn": "Default on",
      "FeatureFlags.DefaultOff": "Default off",
      "Submit": "Provision Tenant",
      "Cancel": "Cancel",
      "Validation.Required": "Required",
      "Validation.SubdomainPattern": "Invalid format",
      "Validation.EmailInvalid": "Invalid email",
      "Status.Title": "Status",
      "Status.AdminUrl": "Admin URL:",
      "Status.CurrentStep": "Current step:",
      "Status.StepPosition": "(step {{position}} of {{total}})",
      "Status.RunStatus": "Status:",
      "Status.LastError": "Last error:",
      "Step.Pending": "Pending",
      "Step.ValidatingInput": "Validating input",
      "Step.CreatingDatabase": "Creating database",
      "Step.CreatingDnsRecords": "Creating DNS records",
      "Step.CommittingInfraChanges": "Committing infra changes",
      "Step.WaitingForArgoSync": "Waiting for ArgoCD sync",
      "Step.RestartingTenantApiPods": "Restarting tenant API pods",
      "Step.WaitingForCertReady": "Waiting for TLS certificate",
      "Step.EnsuringGcpCertMapping": "Provisioning load-balancer TLS",
      "Step.CreatingAuthClients": "Creating auth clients",
      "Step.RunningTenantSetup": "Initializing tenant data",
      "Step.SeedingSampleContent": "Adding sample content",
      "Step.CreatingTenantRecord": "Creating tenant record",
      "Step.FetchingCompanyLogo": "Looking up company logo",
      "Step.Completed": "Completed",
      "Toast.SuccessProvisioned": "Tenant {{subdomain}} provisioned.",
      "Toast.SuccessReady": "Tenant {{subdomain}} ready.",
      "Toast.ProvisioningFailed": "Provisioning failed: {{error}}",
      "Toast.StatusPollingFailed": "Status polling failed: {{error}}",
      "Toast.GenericError": "Provisioning failed.",
      "Retry": "Retry failed run",
      "Deprovision": "Deprovision",
      "DeprovisionKeepDb": "Deprovision (keep database)",
      "DeprovisionDropDb": "Deprovision + drop database",
      "Success.Title": "Tenant provisioned successfully",
      "Success.OpenAdmin": "Open admin",
      "Success.GoToList": "Go to tenant list",
      "Success.ProvisionAnother": "Provision another tenant",
      "Toast.RetryStarted": "Retry of {{subdomain}} started.",
      "Toast.RetryFailed": "Retry failed: {{error}}",
      "Toast.Deprovisioned": "Tenant {{subdomain}} deprovisioned.",
      "Toast.DeprovisionFailed": "Deprovision failed: {{error}}",
      "Toast.DeprovisionStarted": "Deprovisioning of {{subdomain}} started. This takes a few minutes.",
      "Toast.DeprovisionPartial": "Deprovisioning of {{subdomain}} finished with errors: {{error}}. You can trigger it again.",
      "Toast.DeprovisionTimeout": "Deprovisioning of {{subdomain}} is still not finished. Status unknown, check again later.",
      "Toast.DeprovisionPollingFailed": "Status of the deprovisioning of {{subdomain}} could not be read ({{error}}). Check again later.",
      "Dialog.DeprovisionKeepDb.Title": "Deprovision tenant",
      "Dialog.DeprovisionKeepDb.Text": "This removes <strong>{{subdomain}}</strong> from the cluster: DNS records, certificates, gateway routes, and per-tenant secrets. The tenant database is <strong>kept</strong>. The operation is irreversible at the cluster level.",
      "Dialog.DeprovisionDropDb.Title": "Deprovision tenant + drop database",
      "Dialog.DeprovisionDropDb.Text": "This removes <strong>{{subdomain}}</strong> from the cluster AND drops the tenant database (<strong>{{subdomain}}_db</strong>). All podcasts, recordings and users are permanently lost. To confirm, type the subdomain below.",
      "Dialog.DeprovisionConfirm.Label": "Type the subdomain to confirm",
      "Dialog.Cancel": "Cancel",
      "Dialog.Confirm": "Confirm"
    },
    "List": {
      "Created": "Erstellt"
    },
    "Tabs": {
      "Trial": "Testphase & Onboarding",
      "Plan": "Plan",
      "FeatureFlags": "Feature-Flags"
    },
    "Plan": {
      "Title": "Plan",
      "Loading": "Plan wird geladen",
      "Retry": "Erneut versuchen",
      "EffectivePlan": "Gültiger Plan",
      "SourceLabel": "Quelle",
      "StripePlan": "Stripe-Plan",
      "NoStripePlan": "Kein Stripe-Plan",
      "WithPrivateRss": "(+ Private RSS)",
      "NoPlan": "Kein Plan, keine Limits",
      "NoPlanHint": "Dieser Mandant hat keinen Plan, daher gelten keine Limits. Bestandskunden werden nie begrenzt.",
      "UsageTitle": "Limits und Nutzung",
      "UsageUnavailable": "Die Nutzung konnte nicht von der Mandanten-API gelesen werden.",
      "OverLimit": "Über dem Limit",
      "Name": {
        "unlimited": "Unbegrenzt",
        "small": "Small",
        "medium": "Medium",
        "large": "Large"
      },
      "Source": {
        "Stripe": "Stripe-Plan",
        "Override": "Manuell festgelegt",
        "None": "Kein Plan, keine Limits"
      },
      "Mode": {
        "Enforced": "Durchgesetzt",
        "ReportOnly": "Nur Bericht",
        "EnforcedHint": "Die Mandanten-API blockiert neue Podcasts und Creator-Plätze über den Limits.",
        "ReportOnlyHint": "Die Mandanten-API meldet nur, wenn ein Limit überschritten ist, und blockiert nichts."
      },
      "Resource": {
        "podcasts": "Podcasts",
        "creatorSeats": "Creator-Plätze",
        "employees": "Mitarbeitende"
      },
      "Usage": {
        "OfLimit": "{{used}} von {{limit}}",
        "NoLimit": "{{used}} (kein Limit)",
        "Unknown": "-"
      },
      "Override": {
        "Title": "Manuelle Festlegung",
        "Description": "Eine Festlegung ersetzt für die Limits den Plan aus Stripe. Die Abrechnung in Stripe bleibt unverändert.",
        "Label": "Plan",
        "Hint": "Stripe folgen entfernt die Festlegung.",
        "Follow": "Stripe folgen",
        "Save": "Plan speichern",
        "Discard": "Verwerfen"
      },
      "Confirm": {
        "Title": "Plan von {{subdomain}} ändern",
        "TextOverride": "Den Plan von <strong>{{subdomain}}</strong> auf <strong>{{plan}}</strong> setzen? Die Limits dieses Plans gelten sofort, unabhängig vom Plan in Stripe.",
        "TextFollow": "Die Festlegung von <strong>{{subdomain}}</strong> entfernen? Die Limits folgen dann wieder dem Plan in Stripe. Ohne Stripe-Plan ist der Mandant nicht begrenzt.",
        "Save": "Plan speichern"
      },
      "Toast": {
        "Saved": "Plan von {{subdomain}} gespeichert."
      },
      "Error": {
        "NoTenant": "Es wurde kein Mandant ausgewählt.",
        "NotFound": "Es gibt keinen Mandanten mit der Subdomain {{subdomain}}.",
        "Invalid": "Der Plan wurde abgelehnt: {{detail}}",
        "Failed": "Der Plan konnte nicht geladen oder gespeichert werden: {{detail}}"
      },
      "Features": {
        "Title": "Funktionen",
        "Feature": "Funktion",
        "InPlan": "Im Plan",
        "Active": "Aktiv",
        "Status": "Status",
        "Yes": "Ja",
        "No": "Nein",
        "Unknown": "Unbekannt",
        "State": {
          "Pending": "Wird angewendet",
          "PendingHint": "Der Plan enthält diese Funktion. Der Master schaltet sie automatisch ein.",
          "NotInPlan": "Nicht im Plan",
          "NotInPlanHint": "Wird nicht automatisch ausgeschaltet. Bei Bedarf unter Feature-Flags ändern."
        },
        "Summary": {
          "AllMatch": "Alle Funktionen entsprechen dem Plan.",
          "NotInPlanOne": "1 Funktion ist aktiv, aber nicht im Plan.",
          "NotInPlanOther": "{{count}} Funktionen sind aktiv, aber nicht im Plan.",
          "PendingOne": "1 Funktion des Plans wird angewendet.",
          "PendingOther": "{{count}} Funktionen des Plans werden angewendet.",
          "UnknownOne": "Der Zustand von 1 Funktion konnte nicht gelesen werden.",
          "UnknownOther": "Der Zustand von {{count}} Funktionen konnte nicht gelesen werden."
        },
        "NotInPlanHint": "Der Master schaltet ein, was der Plan enthält, schaltet aber nie etwas aus. Diese Funktionen bei Bedarf unter Feature-Flags ändern.",
        "OpenFeatureFlags": "Feature-Flags öffnen",
        "AppliedFor": "Funktionen zuletzt angewendet für Plan:",
        "NotAppliedYet": "noch nicht angewendet",
        "NoPlan": "Kein Plan, Funktionen werden von Hand verwaltet.",
        "PrivateRssNote": "Private RSS auf Spotify/Apple: Einrichtung mit Supporting Cast (manuell)."
      }
    },
    "PlanUsage": {
      "Title": "Plan-Nutzung",
      "Breadcrumb": "Mandanten",
      "Description": "Mandanten mit Plan im Vergleich zu ihren Limits. Mandanten über einem Limit stehen oben.",
      "Loading": "Plan-Nutzung wird geladen",
      "Summary": "{{total}} Mandanten mit Plan, {{over}} über einem Limit",
      "OnlyOverLimit": "Nur über dem Limit",
      "Empty": "Noch kein Mandant hat einen Plan.",
      "EmptyOver": "Kein Mandant ist über einem Limit.",
      "Column": {
        "Tenant": "Mandant",
        "Plan": "Plan",
        "Mode": "Modus"
      }
    }
  },
  "Login": {
    "Email confirmation text": "Vielen Dank, dass du deine E-Mail-Adresse bestätigt hast. Bitte melde dich an, um fortzufahren.",
    "Login title": "Anmeldung",
    "Login": "Anmelden",
    "Password": "Passwort",
    "Email": "E-Mail",
    "The email address is required": "Die E-Mail-Adresse ist erforderlich",
    "The email address is not valid": "Die E-Mail-Adresse ist ungültig",
    "The email address or password do not exist": "E-Mail-Adresse oder Passwort sind ungültig",
    "This account has been blocked": "Dieser Account wurde blockiert",
    "An unknown error has occured": "Ein unbekannter Fehler ist aufgetreten",
    "Your organization is currently deactivated": "Deine Organisation ist zurzeit deaktiviert",
    "Please confirm your email address": "Bitte bestätige deine E-Mail-Adresse",
    "Your password is required": "Dein Passwort ist erforderlich",
    "Forgot password?": "Passwort vergessen?",
    "Imprint": "Impressum",
    "Data protection": "Datenschutzerklärung",
    "Teaser headline": "HYPECAST<br> Your All-in-One Corporate Podcasting Solution",
    "Teaser subline": "Create and distribute your internal and external corporate podcasts - easy and safe! Manage your audio content, premium content, and subscribers in one tool. Create individual audiences and personalized, curated playlist for your audiences."
  }
}
